import "./App.css";
import { ToastContainer } from "react-toastify";
import Loading from "./Subcomponents/Loader";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  useRoutes,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Login from "./Components/Login/Login";
import Leads from "./Components/Leads/Leads";
import Register from "./Components/Register/Register";
import MainPage from "./Pages/Main/MainPage";
import FOSRegisteration from "./Components/FOSRegisteration/FOSRegisterataion";
import FOSList from "./Components/FOSList/FOSList";
import Profile from "./Components/Profile/Profile";
//Store
import action from "./Redux Store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { offlineToast, onlineToast } from "./Services/Toast";
import Projects from "./Components/Projects/Projects";
import Dashboard from "./Components/Dashboard/Dashboard";
import Offline from "./Pages/OfflinePage/Offline";
import MyTarget from "./Components/MyTarget/MyTarget";
import ViewProject from "./Components/Projects/ViewProject/ViewProject";
// ? capacitor network for online/offline status
import { Network } from "@capacitor/network";
import { App as CapacitorApp } from "@capacitor/app";
import ViewLaunches from "./Components/Dashboard/ViewLaunches/ViewLaunches";
import ViewLaunchProject from "./Components/Dashboard/ViewLaunchProject/ViewLaunchProject";
import { Capacitor } from "@capacitor/core";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import Scripts from "./Pages/Scripts/Scripts";
import ForgetPassword from "./Components/ForgetPassword/ForgetPassword";
import { supabase } from "./supabaseClient";
import LogOutSession from "./Modals/LogOutSession/LogOutSession";
import { useRef } from "react";
import FosWallet from "./Components/FosWallet/FosWallet";
import FosDashboard from "./Components/FosDashboard/FosDashboard";
import Agreement from "./Components/Agreement/Agreement";
import Agreements from "./Components/Agreement/Agreements";
import Agreement1 from "./Components/Agreement/Agreement1";
import TicketDashboard from "./Components/HelpDesk/TicketDashboard";
import TicketHistory from "./Components/HelpDesk/TicketHistory";
import TicketDetails from "./Components/HelpDesk/TicketDetails";
import CpSignOffsPage from "./Components/CpSignOffs/CpSignOffs";
import CpPayoutDashBoard from "./Components/CpPayoutDashBoard/CpPayoutDashBoard";

function App() {
  const dispatch = useDispatch();
  dispatch(action.authCheck());
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);
  const [isOnline, setIsOnline] = useState(true);
  const isAuthenticatedUseRef = useRef(false);

  useEffect(() => {
    Network.addListener("networkStatusChange", (status) => {
      console.log("status: ", status);
      // ? status: {
      //     "connected": true,
      //     "connectionType": "wifi"
      // }
      if (status.connected) {
        onlineToast();
        // window.location.reload();        // ! clears all data in registration/add lead forms
      } else {
        offlineToast();
      }
    });
    sessionStorage.clear();
  }, []);

  const [showModal, setShowModal] = useState(false);

  const session_ = supabase.auth.session();
  function logoutUser() {
    setShowModal(true);
    // navigate('/');
  }

  useEffect(() => {
    isAuthenticatedUseRef.current = isAuthenticated;
  }, [isAuthenticated]);

  useEffect(() => {
    console.log("session", session_);
    let flag = false;

    supabase.auth.onAuthStateChange((event, session) => {
      console.log("event and new date", event, new Date());
      console.log(
        "token",
        JSON.parse(localStorage.getItem("supabase.auth.token"))
      );
      console.log("session", session);
      if (
        (event === "TOKEN_REFRESHED" ||
          event === "SIGNED_OUT" ||
          (JSON.parse(localStorage.getItem("supabase.auth.token")) ??
            JSON.parse(localStorage.getItem("supabase.auth.token"))
              ?.expires_at * 1000) < new Date().getTime()) &&
        !flag &&
        !showModal &&
        isAuthenticatedUseRef.current
      ) {
        logoutUser();
        //todo Logout Logic
        flag = true;
      } else {
        flag = false;
        // setShowModal(false);
      }
    });
  }, []);

  const AppWrapper = () => {
    let location = useLocation();
    let navigate = useNavigate();
    useEffect(() => {
      if (Capacitor.isNativePlatform()) {
        // ? handle back button in android app
        CapacitorApp.addListener("backButton", () => {
          console.log("current path: ", location.pathname);
          console.log("back button clicked!");
          if (
            location.pathname === "/Login" ||
            location.pathname === "/Home/Dashboard"
          ) {
            console.log("exiting app");
            CapacitorApp.exitApp();
          } else {
            console.log("going back");
            // location.back();
            navigate(-1);
            console.log("location.pathname: ", location.pathname);
          }
        });
      }
      return () => {
        if (Capacitor.isNativePlatform()) {
          CapacitorApp.removeAllListeners();
        }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
      Network.getStatus().then((resp) => {
        // console.log('resp: ', resp);
        //   resp: {
        //     "connected": true,
        //     "connectionType": "wifi"
        // }
        setIsOnline(resp.connected);
      });
      return () => {
        Network.removeAllListeners();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    let routes = useRoutes([
      {
        path: "/",
        element: JSON.parse(localStorage.getItem("user")) ? (
          (JSON.parse(localStorage.getItem("user"))?.type === "CP" &&
            JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
              "approved") ||
          (JSON.parse(localStorage.getItem("user"))?.type === "FOS" &&
            JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
              "approved" &&
            JSON.parse(localStorage.getItem("user"))?.cpData.approvalStatus ===
              "approved") ? (
            <Navigate to="/Home/Dashboard" />
          ) : (
            <Navigate to="/Home/Profile" />
          )
        ) : (
          <Navigate to={"/Login"} />
        ),
      },
      { path: "/Register", element: <Register /> },
      { path: "/Login", element: <Login /> },
      { path: "/ForgetPassword", element: <ForgetPassword /> },
      { path: "/FosRegisteration", element: <FOSRegisteration /> },
      { path: "/ResetPassword", element: <ResetPassword /> },
      { path: "/Scripts", element: <Scripts /> }, // ! only for scripts
      {
        path: "/Home",
        element: isAuthenticated ? <MainPage /> : <Navigate to="/" />,
        children: [
          {
            path: "",
            element: isAuthenticated ? (
              <Navigate to="/Home/Dashboard" />
            ) : (
              <Navigate to="/" />
            ),
          },
          {
            path: "Dashboard",

            element: isOnline ? (
              JSON.parse(localStorage.getItem("user")) ? (
                (JSON.parse(localStorage.getItem("user"))?.type === "CP" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved") ||
                (JSON.parse(localStorage.getItem("user"))?.type === "FOS" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved" &&
                  JSON.parse(localStorage.getItem("user"))?.cpData
                    .approvalStatus === "approved") ? (
                  JSON.parse(localStorage.getItem("user"))?.type === "FOS" &&
                  JSON.parse(localStorage.getItem("user"))?.isWalletVisible === true
                    ? <FosDashboard />
                    : <Dashboard />
                ) : (
                  <Navigate to="/Home/Profile" />
                )
              ) : (
                <Navigate to={"/"} />
              )
            ) : (
              <Offline />
            ),
          },
              {
      path: "CpSignOffs",  // New route for CpSignOffs
      element: isOnline ? (
        <CpSignOffsPage/>  // Your CpSignOffs component
      ) : (
        <Offline />
      ),
    },
          {
            path: "Leads",
            element: isOnline ? (
              JSON.parse(localStorage.getItem("user")) ? (
                (JSON.parse(localStorage.getItem("user"))?.type === "CP" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved") ||
                (JSON.parse(localStorage.getItem("user"))?.type === "FOS" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved" &&
                  JSON.parse(localStorage.getItem("user"))?.cpData
                    .approvalStatus === "approved") ? (
                  <Leads />
                ) : (
                  <Navigate to="/Home/Profile" />
                )
              ) : (
                <Navigate to={"/"} />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: "FOSList",
            element: isOnline ? (
              JSON.parse(localStorage.getItem("user")) ? (
                (JSON.parse(localStorage.getItem("user"))?.type === "CP" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved") ||
                (JSON.parse(localStorage.getItem("user"))?.type === "FOS" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved" &&
                  JSON.parse(localStorage.getItem("user"))?.cpData
                    ?.approvalStatus === "approved") ? (
                  <FOSList />
                ) : (
                  <Navigate to="/Home/Profile" />
                )
              ) : (
                <Navigate to={"/"} />
              )
            ) : (
              <Offline />
            ),
          },
          { path: "Profile", element: isOnline ? <Profile /> : <Offline /> },
          {
            path: "FosWallet",
            element: isOnline ? <FosWallet /> : <Offline />,
          },
          {
            path: "FosDashboard",
            element: isOnline ? <FosDashboard /> : <Offline />,
          },
          {
            path: "Projects",
            element: isOnline ? (
              JSON.parse(localStorage.getItem("user")) ? (
                (JSON.parse(localStorage.getItem("user"))?.type === "CP" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved") ||
                (JSON.parse(localStorage.getItem("user"))?.type === "FOS" &&
                  JSON.parse(localStorage.getItem("user"))?.approvalStatus ===
                    "approved" &&
                  JSON.parse(localStorage.getItem("user"))?.cpData
                    .approvalStatus === "approved") ? (
                  <Projects />
                ) : (
                  <Navigate to="/Home/Profile" />
                )
              ) : (
                <Navigate to={"/"} />
              )
            ) : (
              <Offline />
            ),
          },
          {
            path: "Agreement",
            element: isOnline ? <Agreement1 /> : <Offline />,
          },
          {
            path:"CpPayoutDashBoard",
            element: isOnline ? <CpPayoutDashBoard /> : <Offline />
          },
          {
            path: "Support",
            element: isOnline ? <TicketDashboard /> : <Offline />,
          },

          {
            path: "ticket-history",
            children: [
              {
                index: true,
                element: isOnline ? <TicketHistory /> : <Offline />,
              },
              {
                path: ":id",
                element: isOnline ? <TicketDetails /> : <Offline />,
              },
            ],
          },

          { path: "MyTarget", element: isOnline ? <MyTarget /> : <Offline /> },
          {
            path: "Project/ViewProject",
            element: isOnline ? <ViewProject /> : <Offline />,
          },
          {
            path: "Dashboard/ViewLaunches",
            element: isOnline ? <ViewLaunches /> : <Offline />,
          },
          {
            path: "Dashboard/ViewLaunches/ViewLaunchProject",
            element: isOnline ? <ViewLaunchProject /> : <Offline />,
          },
        ],
      },
    ]);
    return routes;
  };
  return (
    <>
      <div style={{ height: "100%", paddingTop: "env(safe-area-inset-top)" }}>
        {/* <Router> */}
        <AppWrapper />
        {/* </Router> */}
        <ToastContainer style={{ fontSize: "1.5rem" }} />
        <Loading />
        {showModal && (
          <LogOutSession
            open={showModal}
            handleClose={() => {
              setShowModal(false);
            }}
          />
        )}
      </div>
    </>
  );
}

export default App;
